export default function HeroSection() {
  const handleCTAClick = (ctaType: string) => {
    if (window.gtag) {
      window.gtag('event', 'click', {
        event_category: 'CTA',
        event_label: `Hero ${ctaType}`,
        value: 1
      });
    }
    
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'cta_click',
        cta_location: 'Hero Section',
        cta_type: ctaType
      });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5c62e8017894ab0206b8a32bcbc0eb6c.jpg"
          alt="AI Technology Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 py-20 text-center">
        <div className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: '"Pacifico", serif' }}>
          Curtis Waters AI
        </div>
        <div className="max-w-5xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            AI Solutions Charlotte NC: Deal Evaluation &amp; Business Intelligence
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-100 mb-12 max-w-3xl mx-auto leading-relaxed">
            Expert <strong>deal evaluation</strong> and <strong>business intelligence</strong> services in <strong>Charlotte NC</strong>. Our <strong>AI solutions</strong> deliver <strong>business automation</strong>, predictive analytics, and <strong>data-driven insights</strong> for growing companies seeking <strong>digital transformation</strong>.
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <a
              href="#contact"
              onClick={() => handleCTAClick('Get Started')}
              className="px-10 py-4 bg-red-600 text-white text-lg font-semibold rounded-lg hover:bg-red-700 transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Get Started Today
            </a>
            <a
              href="#solutions"
              onClick={() => handleCTAClick('Learn More')}
              className="px-10 py-4 bg-white/10 backdrop-blur-sm text-white text-lg font-semibold rounded-lg hover:bg-white/20 transition-all border-2 border-white/30 whitespace-nowrap cursor-pointer"
            >
              Explore Solutions
            </a>
          </div>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="text-4xl font-bold text-red-500 mb-2">500+</div>
              <div className="text-white text-sm">Businesses Transformed</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="text-4xl font-bold text-red-500 mb-2">95%</div>
              <div className="text-white text-sm">Client Satisfaction Rate</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="text-4xl font-bold text-red-500 mb-2">24/7</div>
              <div className="text-white text-sm">AI-Powered Support</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-3xl text-white/70"></i>
        </div>
      </div>
    </section>
  );
}